// Centralized invoice amount + period formatters. Internal invariant is
// cents-only; these helpers are the dollar↔string boundary for UI display.

export function formatCents(cents: number | undefined | null): string {
  if (typeof cents !== 'number' || !Number.isFinite(cents)) return '$0.00'
  return '$' + (cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function centsToDollarString(cents: number | undefined): string {
  if (typeof cents !== 'number' || !Number.isFinite(cents)) return '0'
  return (cents / 100).toFixed(2)
}

export function dollarStringToCents(value: string | number): number {
  const numeric = typeof value === 'number' ? value : parseFloat(value)
  if (!Number.isFinite(numeric)) return 0
  return Math.max(0, Math.round(numeric * 100))
}

export function formatPeriodLabel(startISO: string, endISO: string): string {
  const start = isoToMDY(startISO)
  const end = isoToMDY(endISO)
  if (!start || !end) return ''
  return `${start} – ${end}`
}

function isoToMDY(iso: string): string {
  const match = iso.trim().match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!match) return ''
  const [, yyyy, mm, dd] = match
  return `${mm}/${dd}/${yyyy}`
}
